import LandingPage from "./LandingPage.container";

export default LandingPage;
